/**
 * surveyVisibility — minimal shared store so the survey card and the
 * DesktopProFloatingCard can coordinate the bottom-right /home slot without a
 * second `useSurvey` fetch.
 *
 * SurveyFloatingCard publishes whether it currently occupies the /home desktop
 * slot; DesktopProFloatingCard subscribes and steps aside while it's true, so
 * the survey sits "in place of" the upgrade card.
 */
import { useSyncExternalStore } from 'react';

let homeSurveyActive = false;
const listeners = new Set();

export const setHomeSurveyActive = (value) => {
  const next = !!value;
  if (homeSurveyActive === next) return;
  homeSurveyActive = next;
  listeners.forEach((l) => l());
};

const subscribe = (cb) => {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
};

const getSnapshot = () => homeSurveyActive;

/** True when a survey is occupying the /home desktop bottom-right slot. */
export const useHomeSurveyActive = () =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

// ── Listing-detail guided tour ───────────────────────────────────────
// ListingDetailScreen publishes whether its guided tour is running; the global
// desktop SurveyFloatingCard (mounted in _layout) subscribes and steps aside so
// the survey doesn't compete with the tour callouts.
let listingTourActive = false;
const tourListeners = new Set();

export const setListingTourActive = (value) => {
  const next = !!value;
  if (listingTourActive === next) return;
  listingTourActive = next;
  tourListeners.forEach((l) => l());
};

const subscribeTour = (cb) => {
  tourListeners.add(cb);
  return () => {
    tourListeners.delete(cb);
  };
};

const getTourSnapshot = () => listingTourActive;

/** True while the listing-detail guided tour is running (any step > 0). */
export const useListingTourActive = () =>
  useSyncExternalStore(subscribeTour, getTourSnapshot, getTourSnapshot);
